module.exports = __webpack_public_path__ + "static/media/Adora-Bouton.6bf1091e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Adora-Bouton.ttf
// module id = 1491
// module chunks = 40